import React from 'react';
import { formatCurrency, parseAmount, sanitizeAmountInput } from '../../../utils/currency';

interface ReconciliationSectionProps {
  openingCash: number;
  userCashEntered: number;
  nextDayCash: string;
  cashWithdrawal: string;
  suggestedWithdrawalVal: number;
  isArcheoBalanced: boolean;
  showErrorMessage: string | null;
  onNextDayCashChange: (val: string) => void;
  onCashWithdrawalChange: (val: string) => void;
}

export function ReconciliationSection({
  openingCash,
  userCashEntered,
  nextDayCash,
  cashWithdrawal,
  suggestedWithdrawalVal,
  isArcheoBalanced,
  showErrorMessage,
  onNextDayCashChange,
  onCashWithdrawalChange
}: ReconciliationSectionProps) {
  return (
    <div className="rcv-right-col">
      <p className="rcv-right-title">Reconciliación y Cierre de Jornada</p>

      <div className="rcv-panel">
        <h3 className="rcv-panel-title">Ajustes de Fondo Físico</h3>

        <div className="rcv-panel-fields">
          <div className="rcv-opening-cash">
            <span className="rcv-field-label">Fondo de Apertura (Inicial hoy)</span>
            <div className="rcv-opening-row">
              <span className="rcv-opening-value">{formatCurrency(openingCash)}</span>
              <span className="rcv-fixed-badge">Fijo</span>
            </div>
            <span className="rcv-opening-hint">Valor de apertura establecido el día anterior. No modificable.</span>
          </div>

          <label className="rcv-field-sep">
            <span className="rcv-field-sep-label">Fondo de Apertura (Dejar para MAÑANA)</span>
            <div className="rcv-field-input-wrap">
              <input
                type="text"
                inputMode="decimal"
                placeholder="150.00"
                value={nextDayCash}
                onChange={(e) => onNextDayCashChange(sanitizeAmountInput(e.target.value))}
                className="rcv-field-input"
              />
              <span className="rcv-field-euro">€</span>
            </div>
            <span className="rcv-field-hint">Este es el dinero circulante que se deja físicamente en caja para abrir el día siguiente.</span>
          </label>

          <label className="rcv-field-sep">
            <div className="rcv-withdrawal-header">
              <span className="rcv-field-label">Retirada de efectivo</span>
              <span className="rcv-suggested">
                Sugerido: <strong>{formatCurrency(suggestedWithdrawalVal)}</strong>
              </span>
            </div>
            <div className="rcv-field-input-wrap">
              <input
                type="text"
                inputMode="decimal"
                placeholder="0.00"
                value={cashWithdrawal}
                onChange={(e) => onCashWithdrawalChange(sanitizeAmountInput(e.target.value))}
                className="rcv-field-input"
              />
              <span className="rcv-field-euro">€</span>
            </div>
            <span className="rcv-field-hint">Suma de efectivo que se retira de la caja.</span>
          </label>

          {/* Real-time Math Verification Card */}
          <div className="rcv-verification">
            <div className="rcv-verification-title">Verificación de Fórmula de Arqueo</div>
            <div className="rcv-vrow">
              <span className="rcv-vrow-label--bold">Efectivo contado en caja:</span>
              <span className="rcv-vrow-value--orange">{formatCurrency(userCashEntered)}</span>
            </div>
            <span className="rcv-field-hint">Incluye el fondo de apertura de {formatCurrency(openingCash)}.</span>
            <div className="rcv-vsep"></div>
            <div className="rcv-vtotal">
              <span>Suma Disponible:</span>
              <span>{formatCurrency(userCashEntered)}</span>
            </div>
            <div className="rcv-vsep--dashed"></div>
            <div className="rcv-vrow">
              <span className="rcv-vrow-label">Fondo Mañana:</span>
              <span className="rcv-vrow-value--indigo">{formatCurrency(parseAmount(nextDayCash))}</span>
            </div>
            <div className="rcv-vrow">
              <span className="rcv-vrow-label">+ Retirada Efectivo:</span>
              <span className="rcv-vrow-value--blue">{formatCurrency(parseAmount(cashWithdrawal))}</span>
            </div>
            <div className="rcv-vsep"></div>
            <div className="rcv-vtotal">
              <span>Suma Asignada:</span>
              <span>{formatCurrency((parseAmount(nextDayCash)) + (parseAmount(cashWithdrawal)))}</span>
            </div>
            <div className="rcv-verification-result">
              {isArcheoBalanced ? (
                <span className="rcv-balanced">✓ El cálculo cuadra exactamente</span>
              ) : (
                <span className="rcv-unbalanced">✗ Error: Valores no coinciden</span>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="rcv-error-area">
        {showErrorMessage && (
          <div className="rcv-error-msg">
            {showErrorMessage}
          </div>
        )}
      </div>
    </div>
  );
}
